export enum QueryKey {
  getInvoice = 'getInvoice',
  getInvoices = 'getInvoices',
  getOffers = 'getOffers',
}
